import { useState, useEffect } from 'react';
import * as React from 'react';

//React Router
import { Navigate, useNavigate } from 'react-router-dom'
import { useParams } from 'react-router-dom' //useParams to get the ref transmitted in the url


//created components
import HeaderStep from "../../../commons/headerstep/HeaderStep.jsx";
import BannerMoutchicLoisirs from "../../../commons/bannerMoutchicLoisirs/BannerMoutchicLoisirs.jsx";
import ManagerNavBar from "../../../components/managernavbar/ManagerNavBar.jsx"; //<ManagerNavBar idSpotLoc={idSpotLoc} />
import HeaderStepManager from "../../../commons/headerstepmanager/HeaderStepManager.jsx";
import ModalContrat from "../../../components/modalcontrat/ModalContrat.jsx";



//MUI Components
import Button from '@mui/material/Button';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Modal from '@mui/material/Modal';
import CloseIcon from '@mui/icons-material/Close';
import CircularProgress from '@mui/material/CircularProgress';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';

//Redux tools and hooks
import { useSelector, useDispatch } from "react-redux";
import { getIdSpotLoc } from "../../../store/selectors.js";

//Utils
import { checkLoginMaster } from '../../../utils/check-login.js'
//import Fetch API functions
import { getArticles, getAllContratsSearch, getCaisse, getAllContrats } from '../../../database/fetchApi.js'

// data
import listModesPaiements from '../../../database/modes_paiements.json'

// tools and component for date picker
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

// API fetch
import axios from "axios";
import { baseURL } from '../../../config/api-config.js';

//import fr from 'dayjs/locale/fr';
const fr = require('dayjs/locale/fr')
dayjs.locale(fr);

const weekday = require('dayjs/plugin/weekday')
dayjs.extend(weekday)

function ManagerCaisse() { // component to manage the first step of shopping : choosing place and time

    const navigate = useNavigate();
    const [dateRef, setDateRef] = useState(dayjs());
    const [caisse, setCaisse] = useState([]);
    const [resas, setResas] = useState([]);
    const [caisseJour, setCaisseJour] = useState([]);
    const [filteredCaisse, setFilteredCaisse] = useState([]);
    const [caisseSemaine, setCaisseSemaine] = useState([]);
    const [caisseMois, setCaisseMois] = useState([]);
    /* const [resaJour, setResaJour] = useState([]);
    const [filteredResa, setFilteredResa] = useState([]);
    const [resaSemaine, setResaSemaine] = useState([]);
    const [resaMois, setResaMois] = useState([]); */
    const [listSpots, setListSpots] = useState([]);
    const [modeFilter, setModeFilter] = useState(0);
    const [spotFilter, setSpotFilter] = useState(0);
    const [displayMode, setDisplayMode] = useState("liste");


    let idSpotLoc = useSelector(getIdSpotLoc);




    useEffect(() => { //change opening hours when spot change (idspot as dependency)

        if (checkLoginMaster() === false) {
            navigate("/manager/login/caisse");
        }; // if no login, no token, go to login page

        axios.get(baseURL + "/spot").then((response) => {
            setListSpots(response.data);
            //dispatch(spotsListSlice.actions.setSpotsList(listSpots));
        });


        async function initCaisse() { //we add this inner function to manage asynchrone
            let allCaisse = await getCaisse();
            setCaisse(allCaisse);
            setCaisseJour(filterCaisseJour(allCaisse, dateRef, "nofilter"));
            setFilteredCaisse(filterCaisseJour(allCaisse, dateRef, "filter"));
            setCaisseMois(filterCaisseMois(allCaisse, dateRef));
            setCaisseSemaine(filterCaisseSemaine(allCaisse, dateRef));
        } //end of async function
        initCaisse(); //call the inner asnchrone function

        async function initResas() { //we need resas paid online because some are not in the caisse DB
            let allResas = await getAllContrats();
            setResas(allResas.filter(resa => resa.paye > 0 && resa.resa === true));

        } //end of async function
        initResas(); //call the inner asnchrone function

    }, [])


    useEffect(() => { // refill caisse liste with datas from resas list

        if (caisse.length > 0 && resas.length > 0) {
            let newCaisse = caisse.filter(caisse => caisse.type_paiement > 1)
            let newResas = [];

            resas.forEach((resa) => {
                newResas.push({
                    id_caisse: resa.id_contrat,
                    contrat_id: resa.id_contrat,
                    ref_contrat: resa.ref_contrat,
                    type_paiement: 1,
                    montant: resa.total,
                    date_paiement: resa.created,
                    Contrat: resa
                })
            });

            console.log(resas);
            setCaisse(newCaisse.concat(newResas));
        }

    }, [resas])


    useEffect(() => { //change opening hours when spot change (idspot as dependency)

        setCaisseJour(filterCaisseJour(caisse, dateRef, "nofilter"));
        setFilteredCaisse(filterCaisseJour(caisse, dateRef, "filter"));
        setCaisseMois(filterCaisseMois(caisse, dateRef));
        setCaisseSemaine(filterCaisseSemaine(caisse, dateRef));

        console.log(resas);
    }, [dateRef, modeFilter, spotFilter, caisse])




    function filterCaisseJour(list, jour, filter) {

        let caisseJour = list.filter((caisse) => dayjs(caisse.Contrat.date1).isSame(jour, "Day"));
        console.log(caisseJour)

        if (modeFilter > 0 && filter === "filter") {
            caisseJour = [].concat(caisseJour.filter((caisse) => caisse.type_paiement === modeFilter));
        }
        if (spotFilter > 0 && filter === "filter") {
            caisseJour = [].concat(caisseJour.filter((caisse) => caisse.Contrat.spot_id === spotFilter));
        }

        return caisseJour
        //return list
    }

    function filterCaisseMois(list, jour) {

        let caisseMois = list.filter((caisse) => dayjs(caisse.Contrat.date1).isSame(jour, "Month"));

        return caisseMois
        //return list
    }

    function filterCaisseSemaine(list, jour) {

        let caisseSemaine = list.filter((caisse) => dayjs(caisse.Contrat.date1).isSame(jour, "Week"));

        return caisseSemaine
        //return list
    }


    function getTotalJour() {
        let totalJour = 0;

        filteredCaisse.forEach((caisse) => {
            totalJour += caisse.montant;
        })

        return totalJour;
    }

    function getTotalJourTableau(spot, mode) {
        let totalJour = 0;
        let caisseSpot = [].concat(caisseJour);

        if (spot > 0) {
            caisseSpot = [].concat(caisseSpot.filter(caisse => caisse.Contrat.spot_id === spot));
        }

        if (mode > 0) {
            caisseSpot = [].concat(caisseSpot.filter(caisse => caisse.type_paiement === mode))
        }

        caisseSpot.forEach((caisse) => {
            totalJour += caisse.montant;
        })

        return totalJour;
    }

    function getTotalMoisTableau(spot, mode) {
        let totalMois = 0;
        let caisseSpot = [].concat(caisseMois);

        if (spot > 0) {
            caisseSpot = [].concat(caisseSpot.filter(caisse => caisse.Contrat.spot_id === spot));
        }

        if (mode > 0) {
            caisseSpot = [].concat(caisseSpot.filter(caisse => caisse.type_paiement === mode))
        }

        caisseSpot.forEach((caisse) => {
            totalMois += caisse.montant;
        })

        return totalMois;
    }

    function getTotalSemaineTableau(spot, mode) {
        let totalSemaine = 0;
        let caisseSpot = [].concat(caisseSemaine);

        if (spot > 0) {
            caisseSpot = [].concat(caisseSpot.filter(caisse => caisse.Contrat.spot_id === spot));
        }

        if (mode > 0) {
            caisseSpot = [].concat(caisseSpot.filter(caisse => caisse.type_paiement === mode))
        }

        caisseSpot.forEach((caisse) => {
            totalSemaine += caisse.montant;
        })

        return totalSemaine;
    }






    return (
        <main>
            <BannerMoutchicLoisirs title={"Manager : Outil de réservation de vélos"} />
            <ManagerNavBar idSpotLoc={idSpotLoc} />
            <HeaderStepManager title={"Caisse"} />

            <div className="manager-caisse">
                <div className="manager-jour-header-nav">
                    {<LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="fr">
                        <DatePicker
                            sx={{
                                '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': { border: '1px solid #34B0EE' },                               // at page load
                                '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': { border: '2px solid #362782' },  // at hover state
                            }}
                            value={dayjs(dateRef)}
                            label="Choisissez une date"
                            size="small"
                            onChange={(newValue) => setDateRef(dayjs(newValue))}
                            className='manager-jour-header-date-picker'
                        />
                    </LocalizationProvider>}

                    <KeyboardDoubleArrowLeftIcon className="manager-jour-header-nav-arrow" onClick={_ => setDateRef(dateRef.subtract(1, 'day'))} />
                    <p> {dateRef.format('dddd, D MMMM YYYY')}</p>
                    <KeyboardDoubleArrowRightIcon className="manager-jour-header-nav-arrow" onClick={_ => setDateRef(dateRef.add(1, 'day'))} />
                </div>

                <div className="manager-caisse-mode">
                    <div
                        className={displayMode === "liste" ? "manager-caisse-mode-thumb manager-caisse-mode-thumb-selected" : "manager-caisse-mode-thumb"}
                        onClick={_ => setDisplayMode("liste")}>
                        <p>Liste</p>
                    </div>
                    <div
                        className={displayMode === "tableaux" ? "manager-caisse-mode-thumb manager-caisse-mode-thumb-selected" : "manager-caisse-mode-thumb"}
                        onClick={_ => setDisplayMode("tableaux")}>
                        <p>Tableaux</p>
                    </div>
                </div>

                {displayMode === "liste" ?
                    <div className="manager-caisse-display-liste">

                        <div className="manager-caisse-filters">
                            <div className="manager-caisse-filters-modes">
                                <p>Mode de paiement :</p>
                                <Select
                                    className="manager-caisse-filters-modes-select"
                                    value={modeFilter}
                                    label="Mode de paiement"
                                    size="small"
                                    onChange={e => setModeFilter(e.target.value)}
                                >
                                    <MenuItem value={0}>Tous</MenuItem>
                                    {listModesPaiements.map((mode) =>
                                        <MenuItem key={mode.type} value={mode.type}>{mode.intitule}</MenuItem>
                                    )}
                                </Select>
                            </div>

                            <div className="manager-caisse-filters-spot">
                                <p>Point de location :</p>
                                <Select
                                    className="manager-caisse-filters-spot-select"
                                    value={spotFilter}
                                    label="Point de location"
                                    size="small"
                                    onChange={e => setSpotFilter(e.target.value)}
                                >
                                    <MenuItem value={0}>Tous</MenuItem>
                                    {listSpots.map((spot) =>
                                        <MenuItem key={spot.id_spot} value={spot.id_spot}>{spot.nom_spot}</MenuItem>
                                    )}
                                </Select>
                            </div>

                        </div>

                        <div className="manager-caisse-liste">



                            <Table className="list-contrat-tableau">
                                <TableHead>
                                    <TableRow className="list-contrat-tableau-head">
                                        <TableCell align="left">Ref. Contrat</TableCell>
                                        <TableCell>Spot</TableCell>
                                        <TableCell>Mode paiement</TableCell>
                                        <TableCell>Montant</TableCell>
                                        <TableCell>Total contrat</TableCell>
                                        <TableCell>Nom</TableCell>
                                        <TableCell align="right">Date</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                        filteredCaisse.map((caisse, index) => (


                                            <TableRow
                                                className={" "/* getContratPasse(contrat.date1) */}
                                                key={index}
                                            >
                                                <TableCell component="th" scope="row">
                                                    {caisse.ref_contrat}
                                                </TableCell>
                                                <TableCell align="center">{caisse.Contrat.Spot.nom_spot}</TableCell>
                                                <TableCell align="center">{listModesPaiements.find(mode => mode.type === caisse.type_paiement).intitule}</TableCell>
                                                <TableCell align="right">{caisse.montant},00€</TableCell>
                                                <TableCell align="right">{caisse.Contrat.total},00€</TableCell>
                                                <TableCell align="right">{caisse.Contrat.Client.nom}</TableCell>
                                                <TableCell align="right">{dayjs(caisse.Contrat.date1).format("DD/MM/YYYY")}</TableCell>
                                            </TableRow>
                                        ))
                                    }

                                </TableBody>
                            </Table>

                            <div className="manager-caisse-liste-total">
                                <h3>Total du jour </h3>
                                <h4> (pour cette liste) :</h4>
                                <p>{getTotalJour()},00€</p>

                            </div>


                        </div>

                    </div>
                    :
                    <div className="manager-caisse-display-tableaux">

                        <div className="manager-caisse-display-tableaux-jour">
                            <h3>Journée</h3>
                            <Table className="manager-caisse-display-tableaux-table">
                                <TableHead>
                                    <TableRow className="manager-caisse-display-tableaux-table-head">
                                        <TableCell align="left">Point Loc.</TableCell>
                                        <TableCell>Paiement en ligne</TableCell>
                                        <TableCell>Espèces</TableCell>
                                        <TableCell>CB</TableCell>
                                        <TableCell>Chèque</TableCell>
                                        <TableCell>ANCV</TableCell>
                                        <TableCell>Virement</TableCell>
                                        <TableCell align="right">Total</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                        listSpots.map((spot) => (


                                            <TableRow
                                                className={" "/* getContratPasse(contrat.date1) */}
                                                key={spot.id_spot}
                                            >
                                                <TableCell component="th" scope="row">
                                                    {spot.nom_spot}
                                                </TableCell>
                                                <TableCell align="center" className={getTotalJourTableau(spot.id_spot, 1) === 0 ? "tableau-caisse-zero" : ""}>{getTotalJourTableau(spot.id_spot, 1)},00€</TableCell>
                                                <TableCell align="center" className={getTotalJourTableau(spot.id_spot, 2) === 0 ? "tableau-caisse-zero" : ""}>{getTotalJourTableau(spot.id_spot, 2)},00€</TableCell>
                                                <TableCell align="center" className={getTotalJourTableau(spot.id_spot, 3) === 0 ? "tableau-caisse-zero" : ""}>{getTotalJourTableau(spot.id_spot, 3)},00€</TableCell>
                                                <TableCell align="center" className={getTotalJourTableau(spot.id_spot, 4) === 0 ? "tableau-caisse-zero" : ""}>{getTotalJourTableau(spot.id_spot, 4)},00€</TableCell>
                                                <TableCell align="center" className={getTotalJourTableau(spot.id_spot, 5) === 0 ? "tableau-caisse-zero" : ""}>{getTotalJourTableau(spot.id_spot, 5)},00€</TableCell>
                                                <TableCell align="center" className={getTotalJourTableau(spot.id_spot, 6) === 0 ? "tableau-caisse-zero" : ""}>{getTotalJourTableau(spot.id_spot, 6)},00€</TableCell>
                                                <TableCell align="right" className="tableau-caisse-total">{getTotalJourTableau(spot.id_spot, 0)},00€</TableCell>
                                            </TableRow>
                                        ))
                                    }
                                    <TableRow className="">
                                        <TableCell component="th" scope="row">Total</TableCell>
                                        <TableCell align="center" className="tableau-caisse-total">{getTotalJourTableau(0, 1)},00€</TableCell>
                                        <TableCell align="center" className="tableau-caisse-total">{getTotalJourTableau(0, 2)},00€</TableCell>
                                        <TableCell align="center" className="tableau-caisse-total">{getTotalJourTableau(0, 3)},00€</TableCell>
                                        <TableCell align="center" className="tableau-caisse-total">{getTotalJourTableau(0, 4)},00€</TableCell>
                                        <TableCell align="center" className="tableau-caisse-total">{getTotalJourTableau(0, 5)},00€</TableCell>
                                        <TableCell align="center" className="tableau-caisse-total">{getTotalJourTableau(0, 6)},00€</TableCell>
                                        <TableCell align="right" className="tableau-caisse-total">{getTotalJourTableau(0, 0)},00€</TableCell>
                                    </TableRow>

                                </TableBody>
                            </Table>
                        </div>

                        <div className="manager-caisse-display-tableaux-semaine">
                            <h3>Semaine du {dayjs(dateRef).weekday(0).format("DD/MM/YYYY")} au {dayjs(dateRef).weekday(6).format("DD/MM/YYYY")}</h3>
                            <Table className="manager-caisse-display-tableaux-table">
                                <TableHead>
                                    <TableRow className="manager-caisse-display-tableaux-table-head">
                                        <TableCell align="left">Point Loc.</TableCell>
                                        <TableCell>Paiement en ligne</TableCell>
                                        <TableCell>Espèces</TableCell>
                                        <TableCell>CB</TableCell>
                                        <TableCell>Chèque</TableCell>
                                        <TableCell>ANCV</TableCell>
                                        <TableCell>Virement</TableCell>
                                        <TableCell align="right">Total</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                        listSpots.map((spot) => (


                                            <TableRow
                                                className={" "/* getContratPasse(contrat.date1) */}
                                                key={spot.id_spot}
                                            >
                                                <TableCell component="th" scope="row">
                                                    {spot.nom_spot}
                                                </TableCell>
                                                <TableCell align="center" className={getTotalSemaineTableau(spot.id_spot, 1) === 0 ? "tableau-caisse-zero" : ""}>{getTotalSemaineTableau(spot.id_spot, 1)},00€</TableCell>
                                                <TableCell align="center" className={getTotalSemaineTableau(spot.id_spot, 2) === 0 ? "tableau-caisse-zero" : ""}>{getTotalSemaineTableau(spot.id_spot, 2)},00€</TableCell>
                                                <TableCell align="center" className={getTotalSemaineTableau(spot.id_spot, 3) === 0 ? "tableau-caisse-zero" : ""}>{getTotalSemaineTableau(spot.id_spot, 3)},00€</TableCell>
                                                <TableCell align="center" className={getTotalSemaineTableau(spot.id_spot, 4) === 0 ? "tableau-caisse-zero" : ""}>{getTotalSemaineTableau(spot.id_spot, 4)},00€</TableCell>
                                                <TableCell align="center" className={getTotalSemaineTableau(spot.id_spot, 5) === 0 ? "tableau-caisse-zero" : ""}>{getTotalSemaineTableau(spot.id_spot, 5)},00€</TableCell>
                                                <TableCell align="center" className={getTotalSemaineTableau(spot.id_spot, 6) === 0 ? "tableau-caisse-zero" : ""}>{getTotalSemaineTableau(spot.id_spot, 6)},00€</TableCell>
                                                <TableCell align="right" className="tableau-caisse-total">{getTotalSemaineTableau(spot.id_spot, 0)},00€</TableCell>
                                            </TableRow>
                                        ))
                                    }
                                    <TableRow className="">
                                        <TableCell component="th" scope="row">Total</TableCell>
                                        <TableCell align="center" className="tableau-caisse-total">{getTotalSemaineTableau(0, 1)},00€</TableCell>
                                        <TableCell align="center" className="tableau-caisse-total">{getTotalSemaineTableau(0, 2)},00€</TableCell>
                                        <TableCell align="center" className="tableau-caisse-total">{getTotalSemaineTableau(0, 3)},00€</TableCell>
                                        <TableCell align="center" className="tableau-caisse-total">{getTotalSemaineTableau(0, 4)},00€</TableCell>
                                        <TableCell align="center" className="tableau-caisse-total">{getTotalSemaineTableau(0, 5)},00€</TableCell>
                                        <TableCell align="center" className="tableau-caisse-total">{getTotalSemaineTableau(0, 6)},00€</TableCell>
                                        <TableCell align="right" className="tableau-caisse-total">{getTotalSemaineTableau(0, 0)},00€</TableCell>
                                    </TableRow>

                                </TableBody>
                            </Table>
                        </div>

                        <div className="manager-caisse-display-tableaux-mois">
                            <h3>Mois de {dayjs(dateRef).format("MMMM YYYY")}</h3>
                            <Table className="manager-caisse-display-tableaux-table">
                                <TableHead>
                                    <TableRow className="manager-caisse-display-tableaux-table-head">
                                        <TableCell align="left">Point Loc.</TableCell>
                                        <TableCell>Paiement en ligne</TableCell>
                                        <TableCell>Espèces</TableCell>
                                        <TableCell>CB</TableCell>
                                        <TableCell>Chèque</TableCell>
                                        <TableCell>ANCV</TableCell>
                                        <TableCell>Virement</TableCell>
                                        <TableCell align="right">Total</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                        listSpots.map((spot) => (


                                            <TableRow
                                                className={" "/* getContratPasse(contrat.date1) */}
                                                key={spot.id_spot}
                                            >
                                                <TableCell component="th" scope="row">
                                                    {spot.nom_spot}
                                                </TableCell>
                                                <TableCell align="center" className={getTotalMoisTableau(spot.id_spot, 1) === 0 ? "tableau-caisse-zero" : ""}>{getTotalMoisTableau(spot.id_spot, 1)},00€</TableCell>
                                                <TableCell align="center" className={getTotalMoisTableau(spot.id_spot, 2) === 0 ? "tableau-caisse-zero" : ""}>{getTotalMoisTableau(spot.id_spot, 2)},00€</TableCell>
                                                <TableCell align="center" className={getTotalMoisTableau(spot.id_spot, 3) === 0 ? "tableau-caisse-zero" : ""}>{getTotalMoisTableau(spot.id_spot, 3)},00€</TableCell>
                                                <TableCell align="center" className={getTotalMoisTableau(spot.id_spot, 4) === 0 ? "tableau-caisse-zero" : ""}>{getTotalMoisTableau(spot.id_spot, 4)},00€</TableCell>
                                                <TableCell align="center" className={getTotalMoisTableau(spot.id_spot, 5) === 0 ? "tableau-caisse-zero" : ""}>{getTotalMoisTableau(spot.id_spot, 5)},00€</TableCell>
                                                <TableCell align="center" className={getTotalMoisTableau(spot.id_spot, 6) === 0 ? "tableau-caisse-zero" : ""}>{getTotalMoisTableau(spot.id_spot, 6)},00€</TableCell>
                                                <TableCell align="right" className="tableau-caisse-total">{getTotalMoisTableau(spot.id_spot, 0)},00€</TableCell>
                                            </TableRow>
                                        ))
                                    }
                                    <TableRow className="">
                                        <TableCell component="th" scope="row">Total</TableCell>
                                        <TableCell align="center" className="tableau-caisse-total">{getTotalMoisTableau(0, 1)},00€</TableCell>
                                        <TableCell align="center" className="tableau-caisse-total">{getTotalMoisTableau(0, 2)},00€</TableCell>
                                        <TableCell align="center" className="tableau-caisse-total">{getTotalMoisTableau(0, 3)},00€</TableCell>
                                        <TableCell align="center" className="tableau-caisse-total">{getTotalMoisTableau(0, 4)},00€</TableCell>
                                        <TableCell align="center" className="tableau-caisse-total">{getTotalMoisTableau(0, 5)},00€</TableCell>
                                        <TableCell align="center" className="tableau-caisse-total">{getTotalMoisTableau(0, 6)},00€</TableCell>
                                        <TableCell align="right" className="tableau-caisse-total">{getTotalMoisTableau(0, 0)},00€</TableCell>
                                    </TableRow>

                                </TableBody>
                            </Table>
                        </div>

                    </div>
                }


            </div>



        </main>
    )
}




export default ManagerCaisse